//import MainVisual from './top/main-visual/_index';
import Effect from './top/_effect';
// import About from './top/_about';
import Foundation from './top/_foundation';
import Scroll from './top/_scroll';
import Zoom from './top/_zoom';
import Youtube from "./top/_youtube";

//const mainVisual = new MainVisual();
const effect = new Effect();
//const about = new About();
const foundation = new Foundation();
const scroll = new Scroll();
const zoom = new Zoom();
const youtube = new Youtube();